import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImageServiceBlackBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width={130}
    height={51}
    fill='none'
    {...props}
  >
    <path fill='url(#image_service_black_badge_svg__a)' d='M.397.017h129.2v50H.397z' />
    <defs>
      <pattern
        id='image_service_black_badge_svg__a'
        width={1}
        height={1}
        patternContentUnits='objectBoundingBox'
      >
        <use xlinkHref='#image_service_black_badge_svg__b' transform='scale(.00155 .004)' />
      </pattern>
      <image
        xlinkHref='/images/icons/image-service-black-badge-e5375a75.webp'
        id='image_service_black_badge_svg__b'
        width={646}
        height={250}
      />
    </defs>
  </svg>
);
export default SvgImageServiceBlackBadge;
